export default __webpack_public_path__ + "static/media/bonrow.9c099b71.jpg";